module.exports = "https://web-assets.ifttt.com/packs/media/components/checkmark-a9617f29.svg";